module.exports = __webpack_public_path__ + "img/gift1.752649dd.png";